// Importing action types
import {
  FETCH_JOB_DETAILS_REQUEST,
  FETCH_JOB_DETAILS_SUCCESS,
  FETCH_JOB_DETAILS_FAILURE,
} from "../../actions/fetchJobDetailsActions";

// Define the initial state for the reducer
const initialState = {
  isJobDetailsItem: null,  // Initial value for isJobDetailsItem is null
  isLoading: false,    // Initial value for isLoading is false
  isError: null,       // Initial value for isError is null
};

// Define the JobDetailsDataReducer function
const JobDetailsDataReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_JOB_DETAILS_REQUEST:
      // When the FETCH_JOB_DETAILS_REQUEST action is dispatched
      return {
        ...state,
        isLoading: true,   // Set isLoading to true
        isError: null,     // Reset isError to null
      };
    case FETCH_JOB_DETAILS_SUCCESS:
      // When the FETCH_JOB_DETAILS_SUCCESS action is dispatched
      return {
        ...state,
        isJobDetailsItem: action.payload,  // Update isJobDetailsItem with the payload from the action
        isLoading: false,              // Set isLoading to false
        isError: null,                 // Reset isError to null
      };
    case FETCH_JOB_DETAILS_FAILURE:
      // When the FETCH_JOB_DETAILS_FAILURE action is dispatched
      return {
        ...state,
        isLoading: false,              // Set isLoading to false
        isError: action.payload,       // Update isError with the payload from the action
      };
    default:
      // If none of the above action types match, return the current state
      return state;
  }
};

export default JobDetailsDataReducer;
